import { ProductType } from './product-types'

export const SubscriptionService = {
    None: 'None',
    PhoneService: 'PhoneService',
    BookkeepingService: 'BookkeepingService',
    HiringWorkersService: 'HiringWorkersService',
} as const

export type SubscriptionServices = (typeof SubscriptionService)[keyof typeof SubscriptionService]

export const SubscriptionTierVersions = {
    Original: 'Original',
    March2024: 'March2024',
    April2024: 'April2024',
    Feb2025: 'Feb2025',
    Oct2025: 'Oct2025',
} as const

export const SubscriptionTierType = {
    None: 'None',
    Pro: 'Pro',
    Premium: 'Premium',
    Total: 'Total',
    Companies: 'Companies',
    Companies10: 'Companies10',
    Companies20: 'Companies20',
    Companies50: 'Companies50',
    Companies100: 'Companies100',
    Companies200: 'Companies200',
} as const

export type SubscriptionTiers = keyof typeof SubscriptionTierType
export type SubscriptionTierVersion = keyof typeof SubscriptionTierVersions

export interface SubscriptionTierDTO {
    description: string | null
    isOptedIn: boolean
    price: number
    priceIsExcludingVAT: boolean
    subscriptionServices: SubscriptionServices[] | null
    subscriptionTierType: SubscriptionTiers
    upfrontPaymentPrice: number
    productType: ProductType
    version: SubscriptionTierVersion | null
    name: string | null
}

export type SubscriptionTierDetails = {
    tier?: SubscriptionTiers
    title?: string
    name: string
    description: string
    color?: string
    fullIncludes?: string[]
    includes?: string[]
    extra?: string
    listTitle?: string
    includesHashHighlight?: string[]
}

export type SubscriptionTierDetailsByVersion = Record<SubscriptionTierVersion, SubscriptionTierDetails[]>
